/**
 * Open date and opener returned by `PATCH /products/update_stock_item/`.
 *
 * Leaving In Use makes the server set both to null even when the request
 * resent the previous values. A lot that stays not In Use keeps a stored
 * date and opener. Empty strings are treated as cleared.
 *
 * @param {Object|null|undefined} serverItem - `response.data.item`
 * @returns {{ opened_on: string|null, opened_by_name: string|null }}
 */
export function readStockItemOpenFields(serverItem) {
  const openedOn = serverItem?.opened_on;
  const openedBy = serverItem?.opened_by_name;
  return {
    opened_on: openedOn == null || openedOn === '' ? null : String(openedOn),
    opened_by_name: openedBy == null || openedBy === '' ? null : String(openedBy),
  };
}

/**
 * Row to store after a stock-item save. Open date and opener come from the
 * server item, not from the values that were just posted.
 *
 * @param {Object|null|undefined} serverItem
 * @returns {Object|null|undefined}
 */
export function stockItemWithServerOpenFields(serverItem) {
  if (!serverItem || typeof serverItem !== 'object') return serverItem;
  return {
    ...serverItem,
    ...readStockItemOpenFields(serverItem),
  };
}

/**
 * Parent lot the server closed because every component left In Use.
 * The child PATCH does not include the parent, so the row on screen has to
 * drop its open date and opener in the same update that turns In Use off.
 *
 * @param {Object|null|undefined} parent
 * @returns {Object|null|undefined}
 */
export function parentLotClosedByComponents(parent) {
  if (!parent || typeof parent !== 'object') return parent;
  return {
    ...parent,
    in_use: false,
    opened_on: null,
    opened_by_name: null,
  };
}
